import axios from '../axiosInstance';

/**
 * DataGrid-style query for enabled vehicles (keyset pagination, sort, filter).
 * Backend: POST api/Vehicles/queryEnabled
 * Returns: { items, cursor, hasMore }
 */
export async function queryEnabledVehicles({
    search,
    pageSize,
    cursor,
    sortBy,
    sortDir,
    filterModel,
    signal = null,
} = {}) {
    const body = {
        search: search ?? null,
        pageSize,
        cursor: cursor ?? null,
        sortBy: sortBy ?? 'vehicleReg',
        sortDir: sortDir ?? 'asc',
        filterModel: filterModel ?? { items: [], logicOperator: 'and' },
    };

    const { data } = await axios.post('/Vehicles/queryEnabled', body, { signal });
    return data;
}

// GET enabled, paginated (kept for route loader / lookups). Stopped != 'T'
export async function getVehiclesEnabled({ search = '', pageSize = 50, lastId = null, signal = null } = {}) {
    const { data } = await axios.get('/Vehicles/getEnabled', { params: { search, pageSize, lastId }, signal });
    return data; // { items, lastId, hasMore }
}

export async function getVehicleById(id, signal = null) {
    const { data } = await axios.get(`/Vehicles/${id}`, { signal });
    return data;
}

export async function createVehicle(payload, signal = null) {
    const { data } = await axios.post('/Vehicles', payload, { signal });
    return data; // e.g., { id }
}

export async function updateVehicle(id, payload, signal = null) {
    await axios.put(`/Vehicles/${id}`, payload, { signal });
    return true;
}

export async function deleteVehicle(id, signal = null) {
    const { data } = await axios.delete(`/Vehicles/${id}`, { signal });
    return data;
}

export async function saveVehicleTare(id, { weight, reason = null, signal = null } = {}) {
    const { data } = await axios.post('/Tares/saveForVehicle', { id: Number(id), weight, reason }, { signal });
    return data;
}

/**
 * Get PPD (Preferred Product Details) for a vehicle and transaction type.
 * Backend: GET api/Vehicles/getVehiclePpd?vehicleId={vehicleId}&transTypeId={transTypeId}
 * Returns: { accountIds: [], commodityIds: [], haulierIds: [], driverIds: [], contractIds: [], fromLocationIds: [], toLocationIds: [] }
 */
export async function getVehiclePpd({ vehicleId, transTypeId, signal = null } = {}) {
    const { data } = await axios.get('/Vehicles/getVehiclePpd', {
        params: { vehicleId, transTypeId },
        signal,
    });
    return data;
}
